import { useState, useEffect, useRef } from 'react';
const DEFAULT_MINIMUM_LOADING_TIME_MS = 300;
const DEFAULT_SKIP_LOADING_TIME_MS = 30;
export function useThrottledLoading(loading, data, options = {}) {
    const minLoadingTime = options.minimumLoadingTime || DEFAULT_MINIMUM_LOADING_TIME_MS;
    const skipLoadingTime = options.skipLoadingTime || DEFAULT_SKIP_LOADING_TIME_MS;
    const [prevLoading, setPrevLoading] = useState(false);
    const [prevData, setPrevData] = useState();
    const [loadingStartTime, setLoadingStartTime] = useState();
    const startLoadingTimout = useRef();
    const loadingRef = useRef();
    loadingRef.current = loading;
    useEffect(() => {
        const loadingStarted = loading && !prevLoading;
        const loadingEnded = !loading && prevLoading;
        if (loadingStarted) {
            setPrevData(data);
            startLoadingTimout.current = window.setTimeout(() => {
                if (!loadingRef.current)
                    return;
                setLoadingStartTime(Date.now());
            }, skipLoadingTime);
        }
        if (loadingEnded) {
            if (loadingStartTime) {
                const loadingDuration = Date.now() - loadingStartTime;
                const remainingTime = Math.max(minLoadingTime - loadingDuration, 0);
                if (!remainingTime)
                    setLoadingStartTime(undefined);
                else
                    window.setTimeout(() => setLoadingStartTime(undefined), remainingTime);
            }
            else {
                window.clearTimeout(startLoadingTimout.current);
            }
        }
        setPrevLoading(loading);
    }, [
        loading,
        data,
        prevLoading,
        loadingRef,
        loadingStartTime,
        setLoadingStartTime,
        minLoadingTime,
        skipLoadingTime,
    ]);
    return {
        isLoading: !!loadingStartTime,
        data: !loadingStartTime ? data : prevData,
    };
}
//# sourceMappingURL=use-throttled-loading.js.map